import React, { useEffect, useState } from "react";
import { apiPath } from "../../utilities/Constants";
import useFetch from "../../hooks/useFetch";
import { updateData } from "../../hooks/update";
import LoaderFilling from "../../components/shared/Loader/LoaderFilling";
import ReviewCard from "./ReviewCard";
import { deleteData } from "../../hooks/delete";
import Swal from "sweetalert2";
import useSession from "../../hooks/useSession";

function ReviewListPage() {
  const { homeApi } = apiPath;
  const [apiData, apiDataLoading] = useFetch(homeApi);
  const [filteredData, setFilteredData] = useState([]);
  const [user] = useSession();

  // filter by slug
  useEffect(() => {
    setFilteredData(apiData.filter((item) => !item.slug));
  }, [apiData]);

  if (apiDataLoading) {
    return <LoaderFilling />;
  }

  async function handleSingleDelete(id) {
    const swalResponse = await Swal.fire({
      title: "Are you sure you want to delete this?",
      showCancelButton: true,
      confirmButtonText: "Delete",
      showLoaderOnConfirm: true,
      preConfirm: async () => {
        return await deleteData(homeApi, id);
      },
      allowOutsideClick: () => !Swal.isLoading(),
    });
    return swalResponse?.value?.data?._id?.length > 0;
  }

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-2 lg:grid-cols-3 justify-items-center gap-6 lg:gap-8 p-4">
      <ReviewCard />
      {filteredData?.map((item, key) => (
        <ReviewCard
          key={key}
          project={item}
          handleSingleDelete={handleSingleDelete}
          user={user.role}
        />
      ))}
    </div>
  );
}

export default ReviewListPage;
